import styled from "@emotion/styled";
import React from "react";
import { getCompanyData } from "@/app/shared/constants/companies";
import { LogoType } from "@/app/shared/constants/companies/company.types";

const SvgIcon = styled.div`
  display: flex;
  align-self: center;
  height: 100%;
  width: 100%;
  width: fill-available;

  img {
    flex: 0;
    max-width: 100%;
    height: auto;
  }
`;

interface CompanyLogoProps {
  logoName: string;
  iconSrc: string;
  width?: number;
  height?: number;
}

interface CompanyLogoStandardProps {
  size?: number;
}

export const CompanyLogoStandard: React.FC<CompanyLogoStandardProps> = ({
  size = 250,
}) => {
  const companyData = getCompanyData();
  return (
    <CompanyLogo
      iconSrc={companyData.logos[LogoType.STANDARD]}
      logoName={""}
      width={size}
    />
  );
};

export const CompanyLogoSmall: React.FC = () => {
  const companyData = getCompanyData();
  return (
    <CompanyLogo iconSrc={companyData.logos[LogoType.SMALL]} logoName="" />
  );
};

export const CompanyLogoCombined: React.FC = () => {
  const companyData = getCompanyData();
  return (
    <CompanyLogo iconSrc={companyData.logos[LogoType.COMBINED]} logoName="" />
  );
};

export const CompanyLogoSub: React.FC = () => {
  const companyData = getCompanyData();
  return <CompanyLogo iconSrc={companyData.logos[LogoType.SUB]} logoName="" />;
};

const CompanyLogo: React.FC<CompanyLogoProps> = ({
  logoName,
  iconSrc,
  width,
  height,
}) => {
  return (
    <SvgIcon>
      <img
        src={iconSrc}
        alt={logoName}
        style={{
          width: width ? `${width}px` : "auto",
          height: height ? `${height}px` : "auto",
        }}
      />
    </SvgIcon>
  );
};
